type MousePosition = {
  x: number;
  y: number;
};

export const getMousePosition = (event: MouseEvent): MousePosition => {
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  // Get the x and y coordinates of the mouse relative to the viewport
  const mouseX = event.clientX;
  const mouseY = event.clientY;

  // Calculate the center of the viewport
  const centerX = viewportWidth / 2;
  const centerY = viewportHeight / 2;

  // Calculate the distance from the center of the viewport
  const x = parseFloat(((mouseX - centerX) / (0.3 * viewportWidth)).toFixed(4));
  const y = parseFloat(
    ((mouseY - centerY) / (0.3 * viewportHeight)).toFixed(4)
  );

  return {
    x: Math.abs(x) > 1 ? Math.trunc(x) : x,
    y: Math.abs(y) > 1 ? Math.trunc(y) : y
  };
};
